import {
  ConfirmPurchaseModalFormValues,
  PurchaseItems,
} from '@/core/domain/purchase/purchaseImport/PurchaseImport.types';
import { Alert, Col, Form, Input, Table, Typography } from 'antd';
import React from 'react';
import { ColumnsType } from 'antd/es/table/interface';
import CfopSelectField from '@/components/_common/CfopSelectField';
import { getTableScrollX } from '@/utils/table';
import { useDefaultEmptyFieldError } from '@/hooks';
import { useCfopMutation } from '@/core/domain/invoice/cfop/Cfop.hooks';

interface Props {
  hasOutputCfopOnImportPurchase?: boolean;
}

const CfopRelatedToEntry = ({ hasOutputCfopOnImportPurchase }: Props) => {
  const form = Form.useFormInstance<ConfirmPurchaseModalFormValues>();

  const requiredField = useDefaultEmptyFieldError();

  const cfopMutation = useCfopMutation();

  const handlerSelectCfop = async (cfopId: number, index: number) => {
    const response = await cfopMutation.mutateAsync(cfopId);

    form.setFieldValue(['itemsCfop', index, 'cfop'], response);
  };

  const columns: ColumnsType<PurchaseItems> = [
    {
      title: 'CFOP',
      dataIndex: 'entryCode',
      key: 'cfop',
      render: (value) => value,
      width: 30,
    },
    {
      title: '',
      key: 'cfopId',
      render: (_, _row, index) => {
        return (
          <>
            <Form.Item name={[index, 'entryCode']} hidden noStyle>
              <Input />
            </Form.Item>

            <Form.Item
              style={{ margin: 0 }}
              name={[index, 'cfopId']}
              rules={
                hasOutputCfopOnImportPurchase ? [requiredField] : undefined
              }
            >
              <CfopSelectField
                queryFilter={{ output: true }}
                onChange={(cfopId) => handlerSelectCfop(cfopId, index)}
              />
            </Form.Item>
          </>
        );
      },
      width: 150,
      ellipsis: true,
    },
  ];
  return (
    <>
      <>
        <Col lg={24}>
          <Typography.Title level={5}>
            Informe os CFOP's referente a entrada
          </Typography.Title>

          {hasOutputCfopOnImportPurchase && (
            <Alert
              type="info"
              description="A seleção dos CFOPs é obrigatória."
              style={{ marginBottom: 24 }}
            />
          )}

          <Form.List name="itemsCfop" initialValue={[]}>
            {() => {
              const items = form.getFieldValue('itemsCfop') as PurchaseItems[];
              return (
                <Table
                  columns={columns}
                  dataSource={items}
                  rowKey={(_row, index) => String(index)}
                  scroll={{ x: getTableScrollX(columns) }}
                  pagination={false}
                />
              );
            }}
          </Form.List>
        </Col>
      </>
    </>
  );
};

export default CfopRelatedToEntry;
